// Public website content (events, gallery, testimonials). Portal calls live in src/lib/api.js.
import axios from "axios";

const { REACT_APP_API_ENDPOINT } = process.env;

const axiosInstance = axios.create({
  baseURL: `${REACT_APP_API_ENDPOINT}/api/`,
  timeout: 120000,
  headers: { "Content-Type": "application/json" },
});

export const fetchEvents = async () => (await axiosInstance.get("tismain/events/")).data;

export const fetchPicture = async (page = 1) =>
  (await axiosInstance.get(`tismain/pictures/random/?page=${page}&page_size=16`)).data;

export const fetchPicturesByEvent = async (eventName, page = 1) => {
  const response = await axiosInstance.get(
    `tismain/event/${encodeURIComponent(eventName)}/pictures/?page=${page}&page_size=16`
  );
  return {
    results: response.data.results,
    total_pages: response.data.count,
  };
};

export const fetchAllEvents = async () => (await axiosInstance.get("tismain/eventsp/")).data;

export const fetchTestimonials = async () => (await axiosInstance.get("tismain/testimonials/")).data;
